import React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import customStyle from '../styles.module.css';

export const ProcessButton = ({
  children,
  onClick,
  className = '',
  disabled = false,
  style = {},
}) => {
  const onClickHandler = useDebouncedCallback(() => {
    if (onClick) {
      onClick();
    }
  }, 500);

  return (
    <button
      type="button"
      style={style}
      className={`${className} ${disabled ? customStyle.disabled : ''}`}
      onClick={onClickHandler}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
